import extractSecretKey from '../data_management/extractSecretKey'
import updateWorkspace from '../data_management/updateWorkspace'
import addWorkspace from '../data_management/addWorkspace'
import deleteWorkspace from '../data_management/deleteWorkspace'

const WORKSPACES_KEY = 'workspaces';

//TODO: Currently there are two workspaces lists, one in initial data interactor's data and one stored directly in the
// dataService
export default class WorkspaceInteractor {

  constructor(initialDataInteractor, dataService, coachGateway, workspaceGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.dataService = dataService;
    this.coachGateway = coachGateway;
    this.workspaceGateway = workspaceGateway;

    this.dataService.store(WORKSPACES_KEY, {});
    this.workspaceLoaders = {};
  }

  updateWorkspace(memberIds, workspaceId, workspaceName) {
    let data = {
      'id': workspaceId,
      'member_ids': memberIds,
      'name': workspaceName
    };
    //TODO: this needs to also update the workspace in the dataService if there is one there
    return this.coachGateway.updateWorkspace(extractSecretKey(this.initialDataInteractor), data)
      .then(w => {
        updateWorkspace(this.initialDataInteractor, w.id, w.name, w.member_ids);
      });
  }

  createWorkspace(newWorkspace) {
    return this.coachGateway.createWorkspace(this.dataService.secretKey, newWorkspace)
      .then(response => {
        addWorkspace(this.initialDataInteractor, response.name, response.id, response.people);
        return response;
      })
  }

  createWorkspaceWithOrganization(name, organization) {
    return this.coachGateway.createWorkspaceWithOrganization(extractSecretKey(this.initialDataInteractor), {
      'name': name,
      'organization': organization
    })
      .then(response => {
        addWorkspace(this.initialDataInteractor, response.name, response.id, response.people);
        return response;
      })
  }

  archive(workspace) {
    return this.coachGateway.archiveWorkspace(this.dataService.secretKey, workspace.id)
      .then(() => deleteWorkspace(this.initialDataInteractor, workspace.id));
  }

  getQuestionnaires(workspaceId) {
    return this.workspaceGateway.questionnairesOfWorkspace(this.dataService.secretKey, workspaceId);
  }

  addQuestionnaire(workspaceId, questionnaireId) {
    return this.workspaceGateway.addQuestionnaire(this.dataService.secretKey, workspaceId, questionnaireId);
  }

  removeQuestionnaire(workspaceId, questionnaireId) {
    return this.workspaceGateway.removeQuestionnaire(this.dataService.secretKey, workspaceId, questionnaireId);
  }

  isWorkspaceOwner(workspace) {
    return workspace.person_id === this.dataService.person.id;
  }

  purchaseQuestionnaire(workspace, questionnaire, stripeToken) {
    return this.workspaceGateway.purchaseQuestionnaire(this.dataService.secretKey, workspace.id, questionnaire.id, stripeToken ? stripeToken.id : stripeToken);
  }

  //Loading workspace through cache. could be refactored to use a common caching class

  investigationsOfWorkspace(workspaceId) {
    return new Promise(resolve => {
      this.getWorkspace(workspaceId)
        .then(workspace => {
          //TODO: if this could be loaded through an expiring cache, that would be great
          this.coachGateway.investigationsOfWorkspace(this.dataService.secretKey, workspaceId)
            .then(response => {
              workspace.investigations = response.investigations;
              resolve(workspace.investigations);
            });
        });
    });
  }

  getWorkspace(workspaceId) {
    let workspace;

    if (this.workspaceIsLoaded(workspaceId)) {
      workspace = this.retrieveWorkspace(workspaceId);
    } else {
      return this.loadWorkspace(workspaceId);
    }

    return Promise.resolve(workspace);
  }

  workspaceIsLoaded(workspaceId) {
    let workspaces = this.retrieveWorkspaces();
    if (workspaces) return Object.keys(workspaces).includes(workspaceId.toString()); else return false;
  }

  loadWorkspace(workspaceId) {
    let workspaceLoader = this.workspaceLoaders[ workspaceId.toString() ];

    if (!workspaceLoader) {
      workspaceLoader = this.loadWorkspaceFromServer(workspaceId.toString());
      this.workspaceLoaders[ workspaceId.toString() ] = workspaceLoader;
    }

    return workspaceLoader;
  }

  loadWorkspaceFromServer(workspaceId) {
    return this.workspaceGateway.getWorkspace(this.dataService.secretKey, workspaceId)
      .then(response => {
        response.time = Date.now();
        this.storeWorkspace(response);
        return this.retrieveWorkspace(workspaceId);
      });
  }

  storeWorkspace(workspace) {
    let workspaces = this.dataService.retrieve(WORKSPACES_KEY);
    workspaces[ workspace.id.toString() ] = workspace;
  }

  retrieveWorkspaces() {
    return this.dataService.retrieve(WORKSPACES_KEY);
  }

  retrieveWorkspace(workspaceId) {
    return this.retrieveWorkspaces()[ workspaceId.toString() ];
  }
}
